import WRAP from "WRAP-JS";
import {
  _orderBy,
  calcPressureFromAlt,
  formatBaseTime,
  formatValidTime,
  ft2m
} from "../../../utils/FPEUtils";
import {
  configGfsUpperDh,
  configGfsUpperIcingProbController,
  configGfsUpperLayerGeoPotentialHeight,
  configGfsUpperLayerIcingProb,
  configGfsUpperLayerIsotach,
  configGfsUpperLayerIsotachGradation,
  configGfsUpperLayerIsotachMesh,
  configGfsUpperLayerIsotherm,
  configGfsUpperLayerIsothermGradation,
  configGfsUpperLayerIsothermGrid,
  configGfsUpperLayerRelativeHumidityContour,
  configGfsUpperLayerRelativeHumidityGradation,
  configGfsUpperLayerStreamLine,
  configGfsUpperLayerWindArrow,
  configGfsUpperSpeedDirectionController,
  configGfsUpperUpConversionController
} from "./config/ConfigGfsUpper";
import { WX_ID_GFS } from "../../../store/WeatherContentsState";
import { nearValidTime } from "../helper/MapUtil";
import MissingDataObserver from "../helper/MissingDataObserver";
import { COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD } from '../../../constants/ErrorMessage';

class GfsUpper {
  static NAME = `${WX_ID_GFS}_UPPER`;
  static WIND_ARROW_NAME = `${GfsUpper.NAME}_WIND_ARROW`;
  static WIND_STREAM_NAME = `${GfsUpper.NAME}_WIND_STREAM`;
  static ISOTACH_CONTOUR_NAME = `${GfsUpper.NAME}_ISOTACH_CONTOUR`;
  static ISOTACH_MESH_NAME = `${GfsUpper.NAME}_ISOTACH_MESH`;
  static ISOTACH_GRADATION_NAME = `${GfsUpper.NAME}_ISOTACH_GRADATION`;
  static ISOTHERM_CONTOUR_NAME = `${GfsUpper.NAME}_ISOTHERM_CONTOUR`;
  static ISOTHERM_GRADATION_NAME = `${GfsUpper.NAME}_ISOTHERM_GRADATION`;
  static ISOTHERM_GRID_NAME = `${GfsUpper.NAME}_ISOTHERM_VALUE`;
  static GEO_POTENTIAL_HEIGHT_NAME = `${GfsUpper.NAME}_GEO_POTENTIAL_HEIGHT`;
  static ICING_PROB_NAME = `${GfsUpper.NAME}_ICING_PROB_NAME`;
  static RELATIVE_HUMIDITY_CONTOUR_NAME = `${GfsUpper.NAME}_RELATIVE_HUMIDITY_CONTOUR_NAME`;
  static RELATIVE_HUMIDITY_GRADATION_NAME = `${GfsUpper.NAME}_RELATIVE_HUMIDITY_GRADATION_NAME`;
  static CONTENTS_VISIBLE_STATE_DEFAULT = {
    [GfsUpper.WIND_ARROW_NAME]: false,
    [GfsUpper.WIND_STREAM_NAME]: true,
    [GfsUpper.ISOTACH_CONTOUR_NAME]: true,
    [GfsUpper.ISOTACH_MESH_NAME]: true,
    [GfsUpper.ISOTACH_GRADATION_NAME]: false,
    [GfsUpper.ISOTHERM_CONTOUR_NAME]: true,
    [GfsUpper.ISOTHERM_GRADATION_NAME]: false,
    [GfsUpper.ISOTHERM_GRID_NAME]: false,
    [GfsUpper.GEO_POTENTIAL_HEIGHT_NAME]: true,
    [GfsUpper.ICING_PROB_NAME]: true,
    [GfsUpper.RELATIVE_HUMIDITY_CONTOUR_NAME]: true,
    [GfsUpper.RELATIVE_HUMIDITY_GRADATION_NAME]: false
  };

  contentsVisibleState = {...GfsUpper.CONTENTS_VISIBLE_STATE_DEFAULT};
  dh;
  dhSpeedDirectionController;
  dhUpConversionController;
  dhIcingProbController;
  dhAutoUpdate = true;
  ready = false;
  layerWindArrow;
  layerStream;
  layerIsotach;
  layerIsotachMesh;
  layerIsotachGradation;
  layerIsotherm;
  layerIsothermGradation;
  layerIsothermGrid;
  layerGeoPotentialHeight;
  layerIcingProb;
  layerRelativeHumidityContour;
  layerRelativeHumidityGradation;
  etd;
  elapsed = 0;
  baseTime = '---';
  validTime = '---';
  altitude = 0;
  level = '0';
  levelLabel = '';
  dispatcher;
  visible;
  isDark;
  //GFSタイムコントローラー
  timeController
  //自動更新フラグ
  autoRefresh = true;
  errorMessageInfo = {};

  constructor(isDark, timeController) {
    this.isDark = isDark;
    this.timeController = timeController;
    this.layerWindArrow = new WRAP.Geo.Layer(GfsUpper.WIND_ARROW_NAME);
    this.layerStream = new WRAP.Geo.Layer(GfsUpper.WIND_STREAM_NAME);
    this.layerIsotach = new WRAP.Geo.Layer(GfsUpper.ISOTACH_CONTOUR_NAME);
    this.layerIsotachMesh = new WRAP.Geo.Layer(GfsUpper.ISOTACH_MESH_NAME);
    this.layerIsotachGradation = new WRAP.Geo.Layer(GfsUpper.ISOTACH_GRADATION_NAME);
    this.layerIsotherm = new WRAP.Geo.Layer(GfsUpper.ISOTHERM_CONTOUR_NAME);
    this.layerIsothermGradation = new WRAP.Geo.Layer(GfsUpper.ISOTHERM_GRADATION_NAME);
    this.layerIsothermGrid = new WRAP.Geo.Layer(GfsUpper.ISOTHERM_GRID_NAME);
    this.layerGeoPotentialHeight = new WRAP.Geo.Layer(GfsUpper.GEO_POTENTIAL_HEIGHT_NAME);
    this.layerIcingProb = new WRAP.Geo.Layer(GfsUpper.ICING_PROB_NAME);
    this.layerRelativeHumidityContour = new WRAP.Geo.Layer(GfsUpper.RELATIVE_HUMIDITY_CONTOUR_NAME);
    this.layerRelativeHumidityGradation = new WRAP.Geo.Layer(GfsUpper.RELATIVE_HUMIDITY_GRADATION_NAME);

    this.layerWindArrow.setVisible(false);
    this.layerStream.setVisible(false);
    this.layerIsotach.setVisible(false);
    this.layerIsotachMesh.setVisible(false);
    this.layerIsotachGradation.setVisible(false);
    this.layerIsotherm.setVisible(false);
    this.layerIsothermGradation.setVisible(false);
    this.layerIsothermGrid.setVisible(false);
    this.layerGeoPotentialHeight.setVisible(false);
    this.layerIcingProb.setVisible(false);
    this.layerRelativeHumidityContour.setVisible(false);
    this.layerRelativeHumidityGradation.setVisible(false);

    this.layerWindArrow.disableInteraction(true);
    this.layerStream.disableInteraction(true);
    this.layerIsotach.disableInteraction(true);
    this.layerIsotachMesh.disableInteraction(true);
    this.layerIsotachGradation.disableInteraction(true);
    this.layerIsotherm.disableInteraction(true);
    this.layerIsothermGradation.disableInteraction(true);
    this.layerIsothermGrid.disableInteraction(true);
    this.layerGeoPotentialHeight.disableInteraction(true);
    this.layerIcingProb.disableInteraction(true);
    this.layerRelativeHumidityContour.disableInteraction(true);
    this.layerRelativeHumidityGradation.disableInteraction(true);
  }

  setDispatcher(dispatcher) {
    this.dispatcher = dispatcher;
    this.missingDataObserver = new MissingDataObserver(this.dispatcher, MISSING_THRESHOLD, this);
  }

  async initialize() {
    try {
      await this.initData();
    } finally {
      this.initLayer();
      this.initTimeController();
      this.ready = true;
    }
  }

  initData() {
    return new Promise((resolve, reject) => {
      this.dh = new WRAP.Data(configGfsUpperDh);

      this.missingDataObserver.monitoring(GfsUpper.NAME, this.dh, () => ({
        //複数のレイヤーがあるので、ここではvisibleを返すLayerの代わりを設定
        visible: () => this.visible
      }), {
        makeTimelist: (_, ref) => {
          if (!ref) return [];
          return ref.timelist.map(t => t.basetime);
        }
      });

      this.dh.updated('timelist', (ref) => {
        resolve();
        this._selectBaseValidTime(ref);

        if (this.updateTimeFunc) {
          this.updateTimeFunc()
        }
      });
      this.dh.updated('basetime', () => {
        if (this.errorMessageInfo.basetime) {
          this.dispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo.basetime});
          this.errorMessageInfo.basetime = null;
        }
      }, () => {
        this.errorMessageInfo.basetime = this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25,
          replacement: {data: "basetime"},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
        reject();
      });
      this.dh.updated('validtime', () => {
        if (this.errorMessageInfo.validtime) {
          this.dispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo.validtime});
          this.errorMessageInfo.validtime = null;
        }
      }, () => {
        this.errorMessageInfo.validtime = this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25,
          replacement: {data: "validtime"},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
        reject();
      });
      this.dh.updated('region', null, () => {
        this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25,
          replacement: {data: "region"},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
        reject();
      });
      this.dh.updated('level', null, () => {
        this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25,
          replacement: {data: "level"},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
        reject();
      });
      this.dh.updated('element', null, () => {
        this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25,
          replacement: {data: "element"},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
        reject();
      });
      this.dh.updated('updatetime', null, () => {
        this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25,
          replacement: {data: "updatetime"},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
        reject();
      });

      this.dhSpeedDirectionController = new WRAP.Data(configGfsUpperSpeedDirectionController);
      this.dhUpConversionController = new WRAP.Data(configGfsUpperUpConversionController);
      this.dhIcingProbController = new  WRAP.Data(configGfsUpperIcingProbController);

      this.dh.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
      this.dhSpeedDirectionController.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
      this.dhUpConversionController.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
      this.dhIcingProbController.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
    });
  }

  initLayer() {
    this.layerWindArrow.configure(this.dh, configGfsUpperLayerWindArrow);
    this.layerStream.configure(this.dh, configGfsUpperLayerStreamLine);
    this.layerIsotach.configure(this.dhSpeedDirectionController, configGfsUpperLayerIsotach);
    this.layerIsotachMesh.configure(this.dhSpeedDirectionController, configGfsUpperLayerIsotachMesh);
    this.layerIsotachGradation.configure(this.dhSpeedDirectionController, configGfsUpperLayerIsotachGradation);
    this.layerIsotherm.configure(this.dhUpConversionController, configGfsUpperLayerIsotherm);
    this.layerIsothermGradation.configure(this.dhUpConversionController, configGfsUpperLayerIsothermGradation);
    this.layerIsothermGrid.configure(this.dh, configGfsUpperLayerIsothermGrid);
    this.layerGeoPotentialHeight.configure(this.dhUpConversionController, configGfsUpperLayerGeoPotentialHeight);
    this.layerIcingProb.configure(this.dhIcingProbController, configGfsUpperLayerIcingProb);
    this.layerRelativeHumidityContour.configure(this.dhUpConversionController, configGfsUpperLayerRelativeHumidityContour);
    this.layerRelativeHumidityGradation.configure(this.dhUpConversionController, configGfsUpperLayerRelativeHumidityGradation);

    this.applyMapColor(null, this.isDark);

    this.layerWindArrow.setVisible(false);
    this.layerStream.setVisible(false);
    this.layerIsotach.setVisible(false);
    this.layerIsotachMesh.setVisible(false);
    this.layerIsotachGradation.setVisible(false);
    this.layerIsotherm.setVisible(false);
    this.layerIsothermGradation.setVisible(false);
    this.layerIsothermGrid.setVisible(false);
    this.layerGeoPotentialHeight.setVisible(false);
    this.layerIcingProb.setVisible(false);
    this.layerRelativeHumidityContour.setVisible(false);
    this.layerRelativeHumidityGradation.setVisible(false);
  }

  initTimeController() {
    this._allLayers().forEach(layer => {
      this.timeController.addLayer(layer);
    });
    if (this.visible) {
      this.timeController.setDisplayTime(this.validTime);
    }
  }

  async drawLayer(visible) {
    this.visible = visible;
    if (!this.ready && !this.dh) {
      await this.initialize();
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return this._allLayers();
  }

  setVisible(visible, contents) {

    if (contents) {
      this.contentsVisibleState[contents] = visible;
      if (contents === GfsUpper.ISOTACH_CONTOUR_NAME) {
        this.contentsVisibleState[GfsUpper.ISOTACH_MESH_NAME] = visible;
      }
    }

    if (!this.ready) return;

    let target;
    switch (contents) {
      case GfsUpper.WIND_ARROW_NAME:
        target = [this.layerWindArrow];
        break;
      case GfsUpper.WIND_STREAM_NAME:
        target = [this.layerStream];
        break;
      case GfsUpper.ISOTACH_CONTOUR_NAME:
        target = [this.layerIsotach, this.layerIsotachMesh];
        break;
      case GfsUpper.ISOTACH_GRADATION_NAME:
        target = [this.layerIsotachGradation];
        break;
      case GfsUpper.ISOTHERM_CONTOUR_NAME:
        target = [this.layerIsotherm];
        break;
      case GfsUpper.ISOTHERM_GRADATION_NAME:
        target = [this.layerIsothermGradation];
        break;
      case GfsUpper.ISOTHERM_GRID_NAME:
        target = [this.layerIsothermGrid];
        break;
      case GfsUpper.GEO_POTENTIAL_HEIGHT_NAME:
        target = [this.layerGeoPotentialHeight];
        break;
      case GfsUpper.ICING_PROB_NAME:
        target = [this.layerIcingProb];
        break;
      case GfsUpper.RELATIVE_HUMIDITY_CONTOUR_NAME:
        target = [this.layerRelativeHumidityContour];
        break;
      case GfsUpper.RELATIVE_HUMIDITY_GRADATION_NAME:
        target = [this.layerRelativeHumidityGradation];
        break;
      default:
        target = this._allLayers();
    }

    if (visible && this.visible) {
      target.forEach(layer => {
        const layerName = layer.name();
        if (this.contentsVisibleState[layerName] && !this.isElementDisableAtLevel(layerName, this.level)) {
          layer.show();
        }
      });
    } else {
      target.forEach(layer => {layer.hide()})
    }

    if (contents === undefined) {
      const enabled = visible && this.autoRefresh;
      if (this.dhAutoUpdate !== enabled) {
        this.dh.setAutoUpdate('timelist', enabled);
        this.dhSpeedDirectionController.setAutoUpdate('timelist', enabled);
        this.dhUpConversionController.setAutoUpdate('timelist', enabled);
        this.dhIcingProbController.setAutoUpdate('timelist', enabled);
        this.dhAutoUpdate = enabled;
      }
      this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
    }
  }

  getTimeInformation() {
    return {
      id: GfsUpper.NAME,
      label: `GFS ${this.levelLabel.replace(/\s+/g,'')}`,
      baseTime: {
        id: GfsUpper.NAME,
        time: this.baseTime
      },
      validTime: this.validTime,
      baseTimeFormatter: (time) => formatBaseTime(time.time),
      validTimeFormatter: formatValidTime
    };
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  resetContentsVisibleState() {
    this.contentsVisibleState = {...GfsUpper.CONTENTS_VISIBLE_STATE_DEFAULT};
  }

  getIndividualAltitude() {
    return {
      id: GfsUpper.NAME,
      altitude: this.altitude,
      label: 'GFS',
      tooltip: this._altitudeTooltip
    };
  }

  getAltitudeLabel() {
    return this._altitudeTooltip(this.altitude);
  }

  applyIndividualAltitude(altitude) {
    if (this.altitude !== altitude) {
      this.altitude = altitude;
      const level = this._getGfsLevelByAltitude(this.altitude) + '';
      this.applyIndividualLevel(level, this.getAltitudeLabel());
    }
  }

  applyIndividualLevel(level, levelLabel) {
    if (this.level !== level) {
      this.level = level;
      this.levelLabel = levelLabel;
      this._updateElementDisableAtLevel();
      this._updateDataset();
    }
  }

  applyElapsed(elapsed) {
    this.elapsed = elapsed;

    if (!this.ready) return;

    this._selectBaseValidTime(this.dh.retained.timelist);
  }

  applyPlanETD(etd) {
    this.etd = etd;

    if (!this.ready) return;

    this._selectBaseValidTime(this.dh.retained.timelist);
  }

  setAutoRefresh(autoFlg) {
    if (autoFlg === this.autoRefresh) {
      return;
    }

    this.autoRefresh = autoFlg;

    if (!this.ready) {
      return;
    }
    //コンテンツの自動更新を切り替え
    this.dh.setAutoUpdate('timelist', this.autoRefresh);
    this.dhSpeedDirectionController.setAutoUpdate('timelist', this.autoRefresh);
    this.dhUpConversionController.setAutoUpdate('timelist', this.autoRefresh);
    this.dhIcingProbController.setAutoUpdate('timelist', this.autoRefresh);
    this.dhAutoUpdate = this.autoRefresh;
  }

  setUpdateTimeFunc(func) {
    this.updateTimeFunc = func;
  }

  _selectBaseValidTime(ref) {
    let timeList = ref;
    if (!timeList) return;
    timeList = timeList.timelist;

    let targetTime;
    if (!this.etd) {
      //プラン未選択時
      if (!this.autoRefresh) {
        //タイムコントローラ操作時にレーダーを追加した場合、タイムコントローラの選択時制
        targetTime = this.timeController.getCurrentTime();
      } else {
        targetTime = Date.now();
      }
    } else {
      //プラン選択時
      targetTime = this.etd.getTime() + this.elapsed * 1000;
    }

    //最新のbasetimeを取得
    const latestBasetime = _orderBy(timeList, ['basetime'], ['desc'])[0];

    const vt = nearValidTime(latestBasetime.validtime, targetTime);

    if ((vt && this.validTime !== vt) || this.baseTime !== latestBasetime.basetime) {
      this.baseTime = latestBasetime.basetime;
      this.validTime = vt;
      this._updateDataset();
    }
  }

  /**
   * タイムコントロールモード時のvalid選択
   */
  _validateTime(data, displayTime, content) {
    /*
     * autoRefreshのとき、ここでdisplayTimeを調整しないと次の問題がある。
     * TimeControllerのcurrentTimeがGfsLower側にしかない時制が設定されていることがある。
     * 例えばcurrentTimeが16:30とすると、GfsUpperのvalidは1時間ごと[16:00,17:00]
     * なので_validateTimeで直近未来の17:00が選ばれる。（これによってvalid17:00が描画される）
     * その後autoRefreshでGfsUpperの時制が取り直されてvalidTimeが更新される際に現在時刻が16:30以前だとvalidは16:00が選択される。
     * valid16:00で描画されるので直前に17:00で書いたのが無駄になる。という問題
     */
    const _displayTime = new WRAP.Core.DateTime(displayTime);
    //GfsLowerの時刻が指定されている場合
    if (this.autoRefresh && _displayTime.date.getMinutes() === 30 && _displayTime.date.getSeconds() === 0) {
      const now = new WRAP.Core.DateTime();
      const minutes = now.date.getMinutes();
      const seconds = now.date.getSeconds();
      const target = minutes * 60 + seconds;
      if (target < 1800) {
        //現在時刻が30分未満の場合はdisplayTimeから30分引く
        _displayTime.add(-1800);
        displayTime = _displayTime.text();
      }

    }

    //最新のbasetimeを取得
    if (!data.retained.timelist) return false;
    const latestBasetime = _orderBy(data.retained.timelist.timelist, ['basetime'], ['desc'])[0];

    const vt = nearValidTime(latestBasetime.validtime, displayTime);
    if (vt) {
      this.validTime = content.validtime = vt;
      return true;
    }
    return false
  }

  _updateElementDisableAtLevel() {
    if (!this.ready) return;
    // 要素ごとに現在の高度で有効無効かを判定してlayerの描画状態を切り替える
    this._allLayers().forEach(layer => {
      const element = layer.name();
      const disable = this.isElementDisableAtLevel(element, this.level);

      if (this.contentsVisibleState[element] && layer.visible() && disable) {
        // 表示ステートがONでlayerが表示状態だがdisableの要素
        layer.hide();
      } else if (this.contentsVisibleState[element] && layer.visible() === false && !disable) {
        // 表示ステートがONでlayerが非表示だが、enableの要素
        layer.show();
      }
    })
  }

  _updateDataset() {
    if (this.baseTime !== '---' && this.validTime !== '---') {
      this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});

      this.layerWindArrow.set({
        element: ['UWIND', 'VWIND'],
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerStream.set({
        element: ['UWIND', 'VWIND'],
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsotach.set({
        element: "Speed",
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsotachMesh.set({
        element: "Speed",
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsotachGradation.set({
        element: "Speed",
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsotherm.set({
        element: 'AIRTMP',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsothermGradation.set({
        element: 'AIRTMP',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsothermGrid.set({
        element: 'AIRTMP',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerGeoPotentialHeight.set({
        element: 'GPHGT',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIcingProb.set({
        element: 'IcingProb',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerRelativeHumidityContour.set({
        element: 'RHUM',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerRelativeHumidityGradation.set({
        element: 'RHUM',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });
    }
  }

  _getGfsLevelByAltitude(altitude) {
    const gfs_mb = [100, 150, 200, 250, 300, 350, 400, 500, 550, 600, 650, 700, 750, 800, 850, 900, 925, 950, 975, 1000];
    //flightLevel → meter → mb
    const m = ft2m(altitude * 100);
    const mb = calcPressureFromAlt(m);
    const near = _orderBy(gfs_mb,[
      o => {
        return Math.abs(mb - o);
      },
      o => {
        return o;
      }
    ])
    return near[0];
  }

  _altitudeTooltip(altitude) {
    const gfs = [
      {fl: 530, mb: 100}, 
      {fl: 450, mb: 150},
      {fl: 390, mb: 200},
      {fl: 340, mb: 250},
      {fl: 300, mb: 300},
      {fl: 270, mb: 350},
      {fl: 240, mb: 400},
      {fl: 180, mb: 500},
      {fl: 160, mb: 550},
      {fl: 140, mb: 600},
      {fl: 120, mb: 650},
      {fl: 100, mb: 700},
      {fl: 80, mb: 750},
      {fl: 70, mb: 800},
      {fl: 50, mb: 850},
      {fl: 30, mb: 900},
      {fl: 25, mb: 925},
      {fl: 20, mb: 950},
      {fl: 10, mb: 975},
      {fl: 5, mb: 1000},
    ]

    const m = ft2m(altitude * 100);
    const mb = calcPressureFromAlt(m);
    const near = _orderBy(gfs, [
      o => {
        return Math.abs(mb - o.mb);
      },
      o => {
        return o;
      }
    ])[0];
    const fl = ('000' + near.fl).slice(-3);
    return `FL${fl} / ${near.mb}hPa`;
  }

  _allLayers() {
    return [
      this.layerIsothermGradation,
      this.layerIsotherm,
      this.layerIsothermGrid,
      this.layerGeoPotentialHeight,
      this.layerIsotachGradation,
      this.layerIsotachMesh,
      this.layerIsotach,
      this.layerIcingProb,
      this.layerWindArrow,
      this.layerStream,
      this.layerRelativeHumidityGradation,
      this.layerRelativeHumidityContour,
    ];
  }

  applyMapColor(mapColor, isDark) {
    this.isDark = isDark;
    const style = this.isDark ? "dark" : "default";
    this.layerIsothermGrid.setStyle(style);
    this.layerIcingProb.setStyle(style);
  }

  isElementDisableAtLevel(element, level) {
    return (element === GfsUpper.RELATIVE_HUMIDITY_CONTOUR_NAME
        || element === GfsUpper.RELATIVE_HUMIDITY_GRADATION_NAME)
      && ['100', '150', '200', '250'].includes(level);
  }
}

const MISSING_THRESHOLD = {
  [GfsUpper.NAME]: 46800
};


export default GfsUpper;